import dayjs from 'dayjs';

export function dateMonthInterval(monthInterval: number) {
  const datePassed = new Date(
    new Date().setMonth(new Date().getMonth() - monthInterval)
  );
  return dayjs(datePassed).format('YYYY-MM-DD');
}
